import { Point } from 'pixi.js'
import appConfig from '../../data/appConfig'
import { getLatestState } from '../gameState'

export default () => {
	const {
		level: { currentLevelIndex },
	} = getLatestState()
	const { xLimit } = appConfig.level
	const offset = new Point((currentLevelIndex % xLimit) * appConfig.width, -Math.floor(currentLevelIndex / xLimit) * appConfig.height)
	return [-offset.x, -offset.y]
}
